import React from 'react';
import { DialogV2, TextV2, ButtonV2 } from '@withjoy/joykit';
import { TransitionalRegistryStatus } from '@graphql/generated';
import { useAddFromFriendsRegistryScannerDialogController } from './AddFromFriendsRegistryScannerDialog.controller';
import {
  styles,
  MOBILE_TEXT_WIDTH,
  DESKTOP_TEXT_WIDTH,
  StyledTextContainer,
  StyledMediaContainer,
  StyledBackgroundVideo,
  StyledTextContent
} from './AddFromFriendsRegistryScannerDialog.styles';

export interface AddFromFriendsRegistryScannerDialogProps {
  id: string;
  dateString?: string;
  status: TransitionalRegistryStatus;
  onClose: () => void;
  isOpen: boolean;
}

export const AddFromFriendsRegistryScannerDialog: React.FC<AddFromFriendsRegistryScannerDialogProps> = props => {
  const { videoUrl, videoThumbnailUrl, ctaText, translations, statusInfo, handleOnClick, onCloseDialogHandle } = useAddFromFriendsRegistryScannerDialogController(props);
  return (
    <DialogV2 size="5xl" overrides={styles.dialogOverrides} id="AddFromFriendsRegistryScannerDialog" onClose={onCloseDialogHandle} isOpen={props.isOpen}>
      <DialogV2.CloseButton variant="outline" shape="rounded" size="md" />
      <DialogV2.Body style={{ padding: 0 }}>
        <StyledMediaContainer __css={styles.mediaContainer}>
          <StyledBackgroundVideo __css={styles.backgroundVideo(videoThumbnailUrl)}>
            <iframe src={videoUrl} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title={translations.title} />
          </StyledBackgroundVideo>
        </StyledMediaContainer>
        <StyledTextContainer __css={styles.textContainer}>
          <StyledTextContent __css={styles.textContent}>
            <TextV2 typographyVariant={['display1', null, null, 'display2']} color="mono14">
              {translations.title}
            </TextV2>
            <TextV2 typographyVariant={['body1', null, null, 'body2']} color="mono14" marginTop={5}>
              {translations.text}
            </TextV2>
            {statusInfo.status === TransitionalRegistryStatus.ready && (
              <ButtonV2
                intent="neutral"
                marginTop={[7, null, null, 8]}
                marginBottom={[7, null, null, 0]}
                width={[MOBILE_TEXT_WIDTH, null, null, DESKTOP_TEXT_WIDTH]}
                onClick={handleOnClick}
              >
                <TextV2 typographyVariant="button2">{ctaText}</TextV2>
              </ButtonV2>
            )}
          </StyledTextContent>
        </StyledTextContainer>
      </DialogV2.Body>
    </DialogV2>
  );
};
